"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionStylesPanel = void 0;
var react_1 = __importDefault(require("react"));
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var ScrollLock_1 = __importDefault(require("Project/Utils/ScrollLock"));
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ACCORDION_STYLES_PANEL_BASE_CLASS_NAME = "accordion-widget-styles-panel";
var AccordionStylesPanel = (function (_super) {
    __extends(AccordionStylesPanel, _super);
    function AccordionStylesPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.cardStyleOptions = [
            {
                value: BlockStyleTypes_1.AccordionWidgetCardStyle.Simple,
                label: "Simple",
            },
            {
                value: BlockStyleTypes_1.AccordionWidgetCardStyle.Visual,
                label: "Visual",
            },
        ];
        _this.imageHeightOptions = [
            {
                value: BlockStyleTypes_1.AccordionWidgetImageHeight.Small,
                label: "S",
            },
            {
                value: BlockStyleTypes_1.AccordionWidgetImageHeight.Medium,
                label: "M",
            },
            {
                value: BlockStyleTypes_1.AccordionWidgetImageHeight.Large,
                label: "L",
            },
        ];
        _this.buttonStyleOptions = function (isVisualStyleAccordion) {
            var baseButtonStyles = [
                {
                    value: BlockStyleTypes_1.AccordionWidgetButtonStyle.Arrow,
                    label: null,
                    icon: react_1.default.createElement(icons_1.MarkerTriangle, null),
                },
                {
                    value: BlockStyleTypes_1.AccordionWidgetButtonStyle.Expand,
                    label: null,
                    icon: react_1.default.createElement(icons_1.Add, null),
                },
            ];
            var visualButtonStyle = {
                value: BlockStyleTypes_1.AccordionWidgetButtonStyle.Label,
                label: null,
                icon: react_1.default.createElement(icons_1.Button, null),
            };
            if (isVisualStyleAccordion) {
                return __spreadArray(__spreadArray([], __read(baseButtonStyles), false), [visualButtonStyle], false);
            }
            else {
                return baseButtonStyles;
            }
        };
        _this.buttonAlignmentOptions = [
            {
                label: null,
                value: BlockStyleTypes_1.AccordionWidgetButtonAlignment.Left,
                icon: react_1.default.createElement(icons_1.AccordionLeftButton, null),
            },
            {
                value: BlockStyleTypes_1.AccordionWidgetButtonAlignment.Right,
                label: null,
                icon: react_1.default.createElement(icons_1.AccordionRightButton, null),
            },
        ];
        _this.handleHeaderToggle = function (active) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.headerBackground.on = active;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            _this.props.telemetry.accordionToggledHeaderColour(active);
        };
        _this.handleBodyToggle = function (active) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.bodyBackground.on = active;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            _this.props.telemetry.accordionToggledBackgroundColour(active);
        };
        _this.handleHeaderColorChange = function (color) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.headerBackground.color = color;
            if (_this.accordionStyle.buttonColor.value === color.value) {
                if ((0, ColorUtils_1.shouldUseDarkText)(color.value)) {
                    newAccordionStyle.buttonColor = utils_1.DEFAULT_MIDNIGHT;
                }
                else {
                    newAccordionStyle.buttonColor = DefaultColors_1.DEFAULT_WHITE;
                }
            }
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.handleTintColorChange = function (color) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.tint.color = color;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.handleTintOpacityChange = function (opacity) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.tint.opacity = opacity;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.handleButtonStyleChange = function (buttonStyle) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.buttonStyle = buttonStyle;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            _this.props.telemetry.accordionSelectedButtonStyle(buttonStyle);
        };
        _this.handleButtonColorChange = function (color) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.buttonColor = color;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.handleButtonExpandTextChange = function (expandText) {
            _this.expandButtonText = expandText;
            _this.debouncedButtonExpandTextPersist(expandText);
        };
        _this.handleButtonExpandTextPersist = function (expandText) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.expandButtonText = expandText;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.debouncedButtonExpandTextPersist = (0, lodash_1.debounce)(_this.handleButtonExpandTextPersist, 200);
        _this.handleButtonExpandTextFocus = function (event) {
            _this.oldExpandText = event.currentTarget.value;
        };
        _this.handleButtonExpandTextBlur = function (event) {
            var newExpandText = event.currentTarget.value;
            if (!(0, lodash_1.isNil)(_this.oldExpandText) && _this.oldExpandText !== newExpandText) {
                _this.props.telemetry.accordionChangedExpandButtonText(newExpandText);
            }
            _this.oldExpandText = undefined;
        };
        _this.handleButtonCloseTextChange = function (closeText) {
            _this.closeButtonText = closeText;
            _this.debouncedButtonCloseTextPersist(closeText);
        };
        _this.handleButtonCloseTextPersist = function (closeText) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.closeButtonText = closeText;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
        };
        _this.debouncedButtonCloseTextPersist = (0, lodash_1.debounce)(_this.handleButtonCloseTextPersist, 200);
        _this.handleButtonCloseTextFocus = function (event) {
            _this.oldCloseText = event.currentTarget.value;
        };
        _this.handleButtonCloseTextBlur = function (event) {
            var newCloseText = event.currentTarget.value;
            if (!(0, lodash_1.isNil)(_this.oldCloseText) && _this.oldCloseText !== newCloseText) {
                _this.props.telemetry.accordionChangedExpandButtonText(newCloseText);
            }
            _this.oldExpandText = undefined;
        };
        _this.handleCardStyleChange = function (cardStyle) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.cardStyle = cardStyle;
            var isSelectingSimpleAccordion = cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Simple;
            var isSelectingVisualAccordion = cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Visual;
            var hasDarkButton = [DefaultColors_1.DEFAULT_SLATE, utils_1.DEFAULT_MIDNIGHT]
                .map(function (color) { return color.value; })
                .includes(_this.accordionStyle.buttonColor.value);
            var hasLabelButton = _this.accordionStyle.buttonStyle === BlockStyleTypes_1.AccordionWidgetButtonStyle.Label;
            if (isSelectingSimpleAccordion && hasLabelButton) {
                newAccordionStyle.buttonStyle = BlockStyleTypes_1.AccordionWidgetButtonStyle.Arrow;
            }
            if (isSelectingVisualAccordion && hasDarkButton) {
                newAccordionStyle.buttonColor = DefaultColors_1.DEFAULT_WHITE;
            }
            if (isSelectingVisualAccordion) {
                _this.props.onVisualAccordionSelected();
            }
            (0, ScrollLock_1.default)(_this.props.widgetRef.current, function () {
                _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            });
            _this.props.telemetry.accordionSelectedStyle(cardStyle);
        };
        _this.handleImageHeightChange = function (imageHeight) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.imageHeight = imageHeight;
            (0, ScrollLock_1.default)(_this.props.widgetRef.current, function () {
                _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            });
            _this.props.telemetry.accordionChangedImageHeight(imageHeight);
        };
        _this.handleButtonAlignmentChange = function (buttonAlignment) {
            var newAccordionStyle = (0, lodash_1.cloneDeep)(_this.accordionStyle);
            newAccordionStyle.buttonAlignment = buttonAlignment;
            _this.props.blockStore.blockStyleStore.setElementStyle("accordion", newAccordionStyle);
            _this.props.telemetry.accordionSelectedButtonAlignment(buttonAlignment);
        };
        _this.expandButtonText = _this.accordionStyle.expandButtonText;
        _this.closeButtonText = _this.accordionStyle.closeButtonText;
        return _this;
    }
    Object.defineProperty(AccordionStylesPanel.prototype, "accordionStyle", {
        get: function () {
            return this.props.blockStore.blockStyleStore.getElementStyle("accordion");
        },
        enumerable: false,
        configurable: true
    });
    AccordionStylesPanel.prototype.render = function () {
        var _a = this.props, filteredColors = _a.filteredColors, usingVisualAccordion = _a.usingVisualAccordion;
        var _b = this.accordionStyle, headerBackground = _b.headerBackground, bodyBackground = _b.bodyBackground, buttonStyle = _b.buttonStyle, buttonColor = _b.buttonColor, buttonAlignment = _b.buttonAlignment, cardStyle = _b.cardStyle, imageHeight = _b.imageHeight, tint = _b.tint;
        var isVisualStyleAccordion = usingVisualAccordion && this.accordionStyle.cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Visual;
        return (react_1.default.createElement("div", { className: ACCORDION_STYLES_PANEL_BASE_CLASS_NAME },
            react_1.default.createElement(kaleidoscope_1.Tabs, null,
                react_1.default.createElement(kaleidoscope_1.TabList, { isBordered: true, "aria-label": "Style options", align: kaleidoscope_1.TabListAlign.Start, className: "".concat(ACCORDION_STYLES_PANEL_BASE_CLASS_NAME, "__tab-list") },
                    react_1.default.createElement(kaleidoscope_1.Tab, { className: "".concat(ACCORDION_STYLES_PANEL_BASE_CLASS_NAME, "__tab") }, "Card"),
                    react_1.default.createElement(kaleidoscope_1.Tab, { className: "".concat(ACCORDION_STYLES_PANEL_BASE_CLASS_NAME, "__tab") }, "Button")),
                react_1.default.createElement(kaleidoscope_1.TabPanels, null,
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", paddingBottom: "xs" },
                            react_1.default.createElement("div", { className: (0, classnames_1.default)("style-shortcut__main", "".concat(ACCORDION_STYLES_PANEL_BASE_CLASS_NAME, "__main")) },
                                usingVisualAccordion && (react_1.default.createElement("div", { className: "style-shortcut__section" },
                                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Card Style", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.cardStyleOptions, selectedValue: cardStyle, onClickHandler: this.handleCardStyleChange }))),
                                isVisualStyleAccordion && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { className: "style-shortcut__section" },
                                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Image height", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.imageHeightOptions, selectedValue: imageHeight, onClickHandler: this.handleImageHeightChange })),
                                    react_1.default.createElement("div", { className: "style-shortcut__section" },
                                        react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Tint color"),
                                        react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                                            react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: this.handleTintColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(tint.color, filteredColors), type: "content" }))),
                                    react_1.default.createElement(kaleidoscope_1.SliderInput, { theme: kaleidoscope_1.SliderTheme.Dark, label: "Tint opacity", unit: "%", initialInputValue: tint.opacity, handleValueChange: this.handleTintOpacityChange, maximum: 100 }))),
                                !isVisualStyleAccordion && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(kaleidoscope_1.Toggle, { theme: "dark", label: "Header color", value: headerBackground.on, onChange: this.handleHeaderToggle }),
                                    headerBackground.on && (react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: this.handleHeaderColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(this.accordionStyle.headerBackground.color, filteredColors), type: "content" })),
                                    headerBackground.on && (react_1.default.createElement(kaleidoscope_1.Toggle, { theme: "dark", label: "Background color", value: bodyBackground.on, onChange: this.handleBodyToggle }))))))),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", paddingBottom: "xs" },
                            react_1.default.createElement("div", { className: (0, classnames_1.default)("style-shortcut__main", "".concat(ACCORDION_STYLES_PANEL_BASE_CLASS_NAME, "__main")) },
                                react_1.default.createElement("div", { className: "style-shortcut__section" },
                                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Button Style", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.buttonStyleOptions(isVisualStyleAccordion), selectedValue: buttonStyle, onClickHandler: this.handleButtonStyleChange })),
                                react_1.default.createElement("div", { className: "style-shortcut__section" },
                                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Button color"),
                                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                                        react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: this.handleButtonColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(buttonColor, filteredColors), type: "content" }))),
                                isVisualStyleAccordion && buttonStyle === BlockStyleTypes_1.AccordionWidgetButtonStyle.Label && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { className: "style-shortcut__section" },
                                        react_1.default.createElement(kaleidoscope_1.TextInput, { theme: kaleidoscope_1.TextInputTheme.Dark, label: "Expand button text", placeholder: "Expand", value: this.expandButtonText, onChange: this.handleButtonExpandTextChange, maxLength: 50, onFocus: this.handleButtonExpandTextFocus, onBlur: this.handleButtonExpandTextBlur })),
                                    react_1.default.createElement("div", { className: "style-shortcut__section" },
                                        react_1.default.createElement(kaleidoscope_1.TextInput, { theme: kaleidoscope_1.TextInputTheme.Dark, label: "Close button text", value: this.closeButtonText, placeholder: "Collapse", onChange: this.handleButtonCloseTextChange, maxLength: 50, onFocus: this.handleButtonCloseTextFocus, onBlur: this.handleButtonCloseTextBlur })))),
                                !isVisualStyleAccordion && (react_1.default.createElement("div", { className: "style-shortcut__section" },
                                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Button Position", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.buttonAlignmentOptions, selectedValue: buttonAlignment, onClickHandler: this.handleButtonAlignmentChange }))))))))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AccordionStylesPanel.prototype, "expandButtonText", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AccordionStylesPanel.prototype, "closeButtonText", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AccordionStylesPanel.prototype, "accordionStyle", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleHeaderToggle", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleBodyToggle", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleHeaderColorChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleTintColorChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleTintOpacityChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonStyleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonColorChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonExpandTextChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonExpandTextPersist", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonExpandTextBlur", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonCloseTextChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonCloseTextPersist", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonCloseTextBlur", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleCardStyleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleImageHeightChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionStylesPanel.prototype, "handleButtonAlignmentChange", void 0);
    AccordionStylesPanel = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AccordionStylesPanel);
    return AccordionStylesPanel;
}(react_1.default.Component));
exports.AccordionStylesPanel = AccordionStylesPanel;
exports.default = (0, WithColorFilterSubscription_1.default)(AccordionStylesPanel, {
    includeGoldilocksColors: true,
});
